/*
 * Add the right theme colors to the window object
 * so this can be used by the charts and vector maps.
 *
 * The values are read from the Bootstrap CSS custom properties emitted by the
 * loaded stylesheet, so they always match $theme-colors in the SCSS sources and
 * follow whichever theme (light/dark) is active.
 */

const names = ["primary", "secondary", "tertiary", "success", "info", "warning", "danger", "dark"];

const rootStyle = getComputedStyle(document.documentElement);

const theme = names.reduce(function (colors, name) {
  colors[name] = rootStyle.getPropertyValue("--bs-" + name).trim();

  return colors;
}, {});

// Add theme to the window object
window.theme = theme;
